import { tassign } from 'tassign';
import * as _ from 'lodash';

// Own feature
import { Mangel } from '../model/mangel';

import {
   // -- 1. Data from Backend --------------------
   MANGEL_STORE_OBJECTS,

   // -- 2. Reset State --------------------------
   MANGEL_RESET_STATE_ALL,

   // -- 3. Selection ----------------------------
   MANGEL_SELECT_ITEM,

   // -- 4. Item Management ----------------------
   MANGEL_SET_TODELETE,
   MANGEL_SET_TOADD,
   MANGEL_SET_TOEDIT,
   MANGEL_ADD_ITEM,
   MANGEL_DELETE_ITEM,
   MANGEL_EDIT_ITEM,

   // -- 5. Json Schema --------------------------
   MANGEL_STORE_DETAIL_JSS
} from './actions';

export interface IMangelState {
   // -- 1. Data from Backend --------------------
   maengel: Mangel[];
   // -- 3. Selection ----------------------------
   mangelSelected: Mangel;
   // -- 4. Item Management ----------------------
   mangelToAdd: Mangel;
   mangelToEdit: Mangel;
   mangelToDelete: Mangel;
   // -- json schema
   mangelDetailJss: any | null;
}

export const MANGEL_INITIAL_STATE: IMangelState = {
   // -- 1. Data from Backend --------------------
   maengel: null,
   // -- 3. Selection ----------------------------
   mangelSelected: null,
   // -- 4. Item Management ----------------------
   mangelToAdd: null,
   mangelToEdit: null,
   mangelToDelete: null,
   // -- json schema
   mangelDetailJss: null
};

export function mangelReducer(state: IMangelState = MANGEL_INITIAL_STATE, action): IMangelState {
   switch (action.type) {
      // -- 1. Data from Backend ------------------------------------------------------------------
      case MANGEL_STORE_OBJECTS: return storeMaengel(state, action);

      // -- 2. State ------------------------------------------------------------------------------
      case MANGEL_RESET_STATE_ALL: return resetStateAll(state, action);

      // -- 3. Selection --------------------------------------------------------------------------
      case MANGEL_SELECT_ITEM: return selectedMangel(state, action);

      // -- 4. Item Management --------------------------------------------------------------------
      case MANGEL_SET_TOADD: return setMangelToAdd(state, action);
      case MANGEL_SET_TOEDIT: return setMangelToEdit(state, action);
      case MANGEL_SET_TODELETE: return setMangelToDelete(state, action);
      case MANGEL_ADD_ITEM: return addMangel(state, action);
      case MANGEL_EDIT_ITEM: return editMangel(state, action);
      case MANGEL_DELETE_ITEM: return deleteMangel(state, action);

      // -- 5. Json Schema ------------------------------------------------------------------------
      case MANGEL_STORE_DETAIL_JSS: return storeMangelDetailJss(state, action);

      default:
        console.error('Unknown action type in Maengel-Reducer', action.type);

   }
   return state;
}

// ------------------------------------------------------------------------------------------------
// -- 1. Data from Backend ------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function storeMaengel(state, {type: type, payload: {itemSet: items}}) {
   return tassign(state, {
      maengel: items
   });
}

// ------------------------------------------------------------------------------------------------
// -- 2. Reset State ------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function resetStateAll(state, action) {
   const s: IMangelState = MANGEL_INITIAL_STATE;
   return Object.assign({}, state, s);
}

// ------------------------------------------------------------------------------------------------
// -- 3. Selection --------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function selectedMangel(state, {type: type, payload: {selectedItem: item}}) {
   return tassign(state, {
      mangelSelected: item
   });
}

// ------------------------------------------------------------------------------------------------
// -- 4. Item Management --------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function setMangelToAdd(state, {type: type, payload: {itemToAdd: item}}) {
   return tassign(state, {
      // item
      mangelToAdd: item,
      mangelToEdit: null,
      mangelToDelete: null,
   });
}
function setMangelToEdit(state, {type: type, payload: {itemToEdit: item}}) {
   return tassign(state, {
      // item
      mangelToAdd: null,
      mangelToEdit: item,
      mangelToDelete: null,
   });
}
function setMangelToDelete(state, {type: type, payload: {itemToDelete: item}}) {
   return tassign(state, {
      // item
      mangelToAdd: null,
      mangelToEdit: null,
      mangelToDelete: item,
   });
}

function addMangel(state, {type: type,  payload: {itemAdd: item}}) {
   // item null or array
   let _sArr: Mangel[] = null;
   if (!state.maengel) {
      _sArr = [item];
   } else {
      _sArr = _.cloneDeep(state.maengel);
      _sArr.push(item);
   }
   return tassign(state, {
      maengel: _sArr,
   });
}
function editMangel(state, {type: type,  payload: {itemEdit: item}}) {
   // items
   let _sArr: Mangel[] = state.maengel;
   let _sSelected = state.mangelSelected;
   const index = _.findIndex(state.maengel, (obj: Mangel) => obj.uid === item.uid);
   if (index >= 0 && index < state.stocks.length) {
      _sArr = _.cloneDeep(state.stocks);
      _sArr[index] = item;
      if (!!state.mangelSelected) {   // renew selected item
         _sSelected = _sArr[index];
      }
   }
   return tassign(state, {
      maengel: _sArr,
      mangelSelected: _sSelected
   });
}
function deleteMangel(state, {type: type,  payload: {itemDelete: item}}) {
   // item
   let _sArr: Mangel[] = null;
   if (!!state.stocks && state.stocks.length > 1) {
      _sArr = _.filter(state.stocks, (obj) => obj._key !== item._key);
   }
   return tassign(state, {
      // objects
      maengel: _sArr,
      // select
      mangelSelected: null,
      // manage Stock
      mangelToAdd: null,
      mangelToEdit: null,
      mangelToDelete: null,
   });
}

// ------------------------------------------------------------------------------------------------
// -- 5. Json Schema ------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
function storeMangelDetailJss(state, {type: type,  payload: {jss: item}}) {
   return tassign(state, {
      mangelDetailJss: item
   });
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/store/store.ts